// src/pages/playlists/playlistIcons.jsx
// Line icons from the design handoff (playlists-store.jsx → PlsIc).
const svg = (s, kids, extra = {}) => (
  <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...extra}>{kids}</svg>
);

export const PlsIc = {
  save: (s = 18, on = false) =>
    svg(s, on ? <path d="M4 6h12M4 11h12M4 16h6M14 17l2.6 2.6L21.5 14" /> : <path d="M4 6h12M4 11h12M4 16h7M18 13v7M14.5 16.5h7" />),
  plus: (s = 18) => svg(s, <path d="M12 5v14M5 12h14" />, { strokeWidth: 2 }),
  check: (s = 14) => svg(s, <path d="M5 12.5l4.2 4.2L19 7" />, { strokeWidth: 2.6 }),
  x: (s = 16) => svg(s, <path d="M6 6l12 12M18 6L6 18" />, { strokeWidth: 2.2 }),
  play: (s = 14) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M7 4.6v14.8a1 1 0 0 0 1.52.85l12-7.4a1 1 0 0 0 0-1.7l-12-7.4A1 1 0 0 0 7 4.6z" />
    </svg>
  ),
  up: (s = 16) => svg(s, <path d="M6 14.5l6-6 6 6" />, { strokeWidth: 2.1 }),
  down: (s = 16) => svg(s, <path d="M6 9.5l6 6 6-6" />, { strokeWidth: 2.1 }),
  dots: (s = 18) => (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <circle cx="5" cy="12" r="1.7" /><circle cx="12" cy="12" r="1.7" /><circle cx="19" cy="12" r="1.7" />
    </svg>
  ),
  back: (s = 16) => svg(s, <path d="M14.5 6l-6 6 6 6" />, { strokeWidth: 2.1 }),
  pencil: (s = 16) => svg(s, <path d="M4 20h4L19 9l-4-4L4 16v4zM13.5 6.5l4 4" />),
  trash: (s = 16) => svg(s, <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13" />),
  audio: (s = 13) =>
    svg(s, <><path d="M4 15v-3a8 8 0 0 1 16 0v3" /><rect x="3.5" y="14" width="4" height="6.5" rx="1.6" /><rect x="16.5" y="14" width="4" height="6.5" rx="1.6" /></>),
  video: (s = 13) => svg(s, <><rect x="3" y="6" width="13" height="12" rx="2.5" /><path d="M16 10.5l5-3v9l-5-3" /></>),
  list: (s = 28) => svg(s, <path d="M4 6h11M4 12h11M4 18h7M18 14v7M14.5 17.5h7" />, { strokeWidth: 1.6 }),
  search: (s = 16) => svg(s, <><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.8-3.8" /></>, { strokeWidth: 2 }),
};
